import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PageHeader from '../../components/PageHeader/PageHeader';
import MetricRow from '../../components/MetricRow/MetricRow';
import MetricCard from '../../components/MetricCard/MetricCard';
import Badge from '../../components/Badge/Badge';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import styles from './PayoutBatch.module.css';

const PayoutBatch = () => {
  const navigate = useNavigate();
  const [showApproveModal, setShowApproveModal] = useState(false);

  const headerBadge = <Badge variant="warning">Pending approval</Badge>;

  const headerActions = (
    <Button
      variant="primary"
      onClick={() => setShowApproveModal(true)}
    >
      Approve batch
    </Button>
  );

  const modalFooter = (
    <>
      <Button variant="secondary" onClick={() => setShowApproveModal(false)}>
        Cancel
      </Button>
      <Button
        variant="primary"
        onClick={() => {
          setShowApproveModal(false);
          navigate('/payments');
        }}
      >
        Confirm & pay
      </Button>
    </>
  );

  return (
    <>
      <PageHeader
        backTo="/payments"
        backText="← Payments"
        title="Batch PB-0929"
        badge={headerBadge}
        subtitle="Scheduled for Sep 29, 2026 · 48 participant payouts"
        actions={headerActions}
      />

      <MetricRow columns={4}>
        <MetricCard label="Total sum" value="₹2,45,000" subtext="escrow funded" />
        <MetricCard label="Recipients" value="48" subtext="verified participants" />
        <MetricCard label="Method" value="UPI" subtext="instant disbursement" />
        <MetricCard label="Risk verdict" value="Clean" subtext="0 flagged items" isGreen />
      </MetricRow>

      <section className={styles.tableCard}>
        <div className={styles.tableHeader}>
          <div>Participant</div>
          <div>UPI ID</div>
          <div>Study</div>
          <div>Amount</div>
        </div>

        <div className={styles.tableRow}>
          <span className={styles.participantName}>Aman Sharma</span>
          <span className={styles.upiText}>amansharma@okaxis</span>
          <span className={styles.studyText}>Footwear CLT</span>
          <span className={styles.amountText}>₹600</span>
        </div>

        <div className={styles.tableRow}>
          <span className={styles.participantName}>Sneha Patel</span>
          <span className={styles.upiText}>snehap@upi</span>
          <span className={styles.studyText}>Mothers' Chocolate</span>
          <span className={styles.amountText}>₹1000</span>
        </div>

        <div className={styles.tableRow}>
          <span className={styles.participantName}>Vikram Joshi</span>
          <span className={styles.upiText}>vikramj@paytm</span>
          <span className={styles.studyText}>MDR Audio Devices</span>
          <span className={styles.amountText}>₹1500</span>
        </div>
      </section>

      <Modal
        isOpen={showApproveModal}
        onClose={() => setShowApproveModal(false)}
        title="Confirm payout batch"
        footer={modalFooter}
        maxWidth={480}
      >
        <p className={styles.modalText}>
          You are authorizing an instant disbursement of <strong>₹2,45,000</strong> to 48 verified participants via RazorpayX UPI gateway.
        </p>
      </Modal>
    </>
  );
};

export default PayoutBatch;
